import { Checkbox } from 'antd';
import { kebabCase } from 'lodash';
import React, { FC, ReactNode } from 'react';
import { Loading } from 'components/atoms/loading';
import {
  Description,
  FeatureControlWrapper,
  PrimaryTitle,
  SecondaryTitle,
} from './styles';

interface TitleProps {
  primaryTitle: ReactNode;
  secondaryTitle?: ReactNode;
}

interface FeatureControlProps {
  controlName: string;
  isEnabled: boolean;
  description: ReactNode;
  onChange: (controlType: string, isEnabled: boolean) => void;
  isLoading: boolean;
}

export const SettingToggleTitle: FC<TitleProps> = ({
  primaryTitle,
  secondaryTitle,
}) => (
  <Description>
    <PrimaryTitle>{primaryTitle}</PrimaryTitle>
    {secondaryTitle && <SecondaryTitle>: {secondaryTitle}</SecondaryTitle>}
  </Description>
);

export const FeatureControl: FC<FeatureControlProps> = ({
  controlName,
  isEnabled,
  description,
  onChange,
  isLoading,
}) => (
  <FeatureControlWrapper
    data-cy={`settings.resource-management.soft-allocations.controls.${kebabCase(
      controlName,
    )}`}
  >
    {isLoading ? (
      <Loading />
    ) : (
      <Checkbox
        checked={isEnabled}
        onChange={() => onChange(controlName, !isEnabled)}
      />
    )}

    <Description>{description}</Description>
  </FeatureControlWrapper>
);
